import { call, put, takeLatest } from 'redux-saga/effects'

import { NOTIFICATION_TYPE } from '~/common/constants'
import addNotification from '~/utils/toast'

import {
  actUpdateVehicleCategoriesFailed,
  actUpdateVehicleCategoriesSuccess,
  MASTER_UPDATE_VEHICLE_CATEGORIES,
} from '../../actions/vehicle-categories'
import { apiUpdateVehicleCategories } from '../../apis/vehicle-categories'

/**
 * Handle get data request and response
 * @param {object} action
 */
function* doUpdate(action) {
  try {
    const response = yield call(apiUpdateVehicleCategories, action?.payload)

    if (response?.statusCode === 200) {
      yield put(actUpdateVehicleCategoriesSuccess({ data: response.data }))
      // Call callback action if provided
      if (action.onSuccess) {
        yield action.onSuccess()
      }
      addNotification(
        'vehicleCategories.notification.updateSuccess',
        NOTIFICATION_TYPE.SUCCESS,
      )
    } else {
      addNotification(response?.message, NOTIFICATION_TYPE.ERROR)
      throw new Error(response?.message)
    }
  } catch (error) {
    yield put(actUpdateVehicleCategoriesFailed())
    // Call callback action if provided
    if (action.onError) {
      yield action.onError(error)
    }
  }
}

export default function* watchUpdate() {
  yield takeLatest(MASTER_UPDATE_VEHICLE_CATEGORIES, doUpdate)
}
